import { createSelector } from 'reselect';

const selectFirstVideoShareModal = state => state.firstVideoShareModal;

export const selectFirstVideoShareModalIsOpen = createSelector(
  selectFirstVideoShareModal,
  modal => modal.isOpen
);
